var exports = {
  "a": "Box__zLh7iC",
};

module.exports = exports;
